import http from "../httpService";

export const getApi = async ({ path, params, responseType }) => {
  console.log("getApi  : ", path, params);
  return await http.GET(`${path}`, { params, responseType });
};

export const postApi = async ({ path, body, headers }) => {
  console.log("postApi  : ", path, body);
  return await http.POST(`${path}`, body, { headers });
};

export const putApi = async ({ path, body }) => {
  console.log("putApi  : ", path, body);
  return await http.PUT(`${path}`, body);
};

export const deleteApi = async ({ path, body }) => {
  console.log("deleteApi  : ", path, body);
  return await http.DELETE(`${path}`, body);
};

export const patchApi = async ({ path, body }) => {
  console.log("patchApi  : ", path, body);
  return await http.PATCH(`${path}`, body);
};
